import {axiosInstance} from '../helper/appclient'
import get from 'lodash/get'
import {CLR_PRESIGN_URL} from '../config/url-config'

import {
    ERR_MSG,
    LOG_ERR_101,
    LOG_ERR_102,
    LOG_ERR_103,
    LOG_ERR_104, LOG_ERR_105, LOG_ERR_106, LOG_ERR_107, LOGIN_ATTEMPT_ERR, LOGIN_CRED_ERR,
    TEMP_PASS_EXPIRED, UNK_ERR_102
} from "../constants/constants";

import fileDownload from "js-file-download";
import {
    CLR_FILE_STATUS,
    CLR_FILE_STATUS_AVAILABLE,
    CLR_FILE_STATUS_UNAVAILABLE
} from "@app/dslcommonlogin/src/constants/appconstants";

export const loginStatus = {
    [LOG_ERR_101]: TEMP_PASS_EXPIRED,
    [LOG_ERR_102]:LOGIN_CRED_ERR,
    [UNK_ERR_102]: ERR_MSG,
    [LOG_ERR_103]: ERR_MSG,
    [LOG_ERR_104]: ERR_MSG,
    [LOG_ERR_105]: LOGIN_CRED_ERR,
    [LOG_ERR_106]: LOGIN_ATTEMPT_ERR,
    [LOG_ERR_107]:ERR_MSG,

};

export const clrPreSignURLService = ()=>{

    return new Promise((resolve,reject)=>{
        axiosInstance
            .get(CLR_PRESIGN_URL())
            .then((response) => {
                let status = get(response,"status")
                let statusDesc = get(response,"statusDesc")
                if(status === CLR_FILE_STATUS_AVAILABLE){
                    resolve(response)
                }else if(status === CLR_FILE_STATUS_UNAVAILABLE){
                    console.log("eentered")
                    reject(statusDesc)
                }
                reject(ERR_MSG)
            })
            .catch((error) => {
                console.log(error)
                reject(ERR_MSG)
            });
    })
}